import React, { useMemo } from 'react';
import { ThemeProvider as JssThemeProvider } from 'react-jss';

import { theme } from './theme';
import { muiTheme } from './muiTheme';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

interface Props {
  children: React.ReactNode;
}

export const ThemeProvider = ({ children }: Props) => {
  return (
    <JssThemeProvider theme={theme}>
      <MuiThemeProvider theme={muiTheme}>{children}</MuiThemeProvider>
    </JssThemeProvider>
  );
};
